import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import styles from './ReportInfo.module.scss';

type ReportInfoProps = {
  reportTitle: string;
  patientFullName: string;
  patientDoB: string;
  studyFormattedDate: string;
  className?: string;
};

export const ReportInfo: FC<ReportInfoProps> = (props) => {
  const {
    reportTitle,
    patientFullName,
    patientDoB,
    studyFormattedDate,
    className,
  } = props;

  const { formatMessage } = useIntl();

  return (
    <div
      className={cn(styles.container, className)}
      data-component="preview-report-info"
    >
      <div className={styles.leftSection}>
        <h3 className={cn(styles.reportTitle, 'h3')}>{reportTitle}</h3>

        <p className={cn(styles.infoText, 'p3')}>
          {patientFullName}, {patientDoB}
        </p>
      </div>

      <div className={styles.rightSection}>
        <p className={cn(styles.infoText, 'p3')}>
          {formatMessage({
            id: 'patientInfo.studyDate',
            defaultMessage: 'Study Date',
          })}
        </p>

        <p className={cn(styles.infoText, 'p3')}>{studyFormattedDate}</p>
      </div>
    </div>
  );
};
